import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient"; // Supabase bağlantısı
import "./App.css"; // Stil dosyası

function BizKimiz() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  // Supabase'den veriyi çek
  useEffect(() => {
    const fetchContent = async () => {
      const { data, error } = await supabase
        .from("headings")
        .select("*")
        .eq("subtitle", "Biz Kimiz")
        .single(); // Tek bir veri almak için

      if (error) {
        console.error("Hata:", error);
      } else {
        setContent(data);
      }
      setLoading(false);
    };

    fetchContent();
  }, []);

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (!content) {
    return <div>İçerik bulunamadı.</div>;
  }

  return (
    <div className="about-us section-container">
      <div className="text-section">
        <h1>{content.subtitle}</h1>
        {/* HTML içeriği göstermek için dangerouslySetInnerHTML kullanıyoruz */}
        <div
          dangerouslySetInnerHTML={{ __html: content.content }}
          className="content-html"
        ></div>
      </div>
      {content.img_url && (
        <div className="image-section">
          <img
            src={content.img_url}
            alt="Biz Kimiz Görseli"
            className="about-image"
          />
        </div>
      )}
    </div>
  );
}

export default BizKimiz;
